var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1543 4C9.5303 4 4.1543 9.376 4.1543 16C4.1543 22.624 9.5303 28 16.1543 28C22.7783 28 28.1543 22.624 28.1543 16C28.1543 9.376 22.7783 4 16.1543 4ZM12.9023 21.148L8.5943 16.84C8.1263 16.372 8.1263 15.616 8.5943 15.148C9.0623 14.68 9.8183 14.68 10.2863 15.148L13.7543 18.604L22.0103 10.348C22.4783 9.88 23.2343 9.88 23.7023 10.348C24.1703 10.816 24.1703 11.572 23.7023 12.04L14.5943 21.148C14.1383 21.616 13.3703 21.616 12.9023 21.148Z",
    fill: "#4AA434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.06ed844137f4fbddcffb09510eab2ecc.svg";
export { ForwardRef as ReactComponent };